<template>
  <div class="d-flex flex-column overflow-hidden h-100">
    <vue-custom-scrollbar
      class="app-content-padding flex-grow-1 overflow-hidden h-100"
    >
      <ts-page-title
        :title="$t('trainerProfile.pageTitle')"
        :breadcrumb="[
          { text: $t('home'), href: '/' },
          {
            text: $t('trainerProfile.pageTitle'),
            href: '/admin/academic/trainer-profiles',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
      <ts-loading-banner :loading="waiting">
        <div class="row">
          <div class="col-md-3">
            <profile
              v-model="model"
              :validate="errors"
              class="tw-h-full"
              ref="profile"
            />
          </div>
          <div class="col-md-9">
            <ts-panel>
              <ts-panel-wrapper>
                <form class="form-horizontal form-horizontal-text-right">
                  <details-template v-model="model" :validation="errors" />
                  <address-template v-model="model" :validation="errors" />
                  <skill-level-detail-template
                    v-model="model"
                    :validation="errors"
                  />
                </form>
              </ts-panel-wrapper>
            </ts-panel>
          </div>
        </div>
      </ts-loading-banner>
    </vue-custom-scrollbar>
    <div
      id="footer"
      class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2 tw-sh"
      style="background-color: #e9ecef"
    >
      <ts-button
        @click.prevent="$router.push({ name: 'trainer-profile' })"
        class="btn-gray"
      >
        {{ $t("cancel") }}</ts-button
      >
      <ts-button :waiting="waiting" @click.prevent="onUpdate" color="primary">
        {{ $t("update") }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import Profile from "./components/profile.vue";
import DetailsTemplate from "./components/detail.vue";
import AddressTemplate from "./components/address.vue";
import SkillLevelDetailTemplate from "./components/skill-level-detail.vue";
import { mapActions, mapState } from "vuex";
import { Errors } from "form-backend-validation";
import moment from "moment";
import { isEmpty } from "lodash";

export default {
  name: "trainerProfileEdit",
  components: {
    Profile,
    DetailsTemplate,
    AddressTemplate,
    SkillLevelDetailTemplate,
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        fname_kh: "",
        lname_kh: "",
        fname_en: "",
        lname_en: "",
        sex: null,
        dob: moment().format("DD-MM-YYYY"),
        nationality_id: null,
        register_date: moment().format("DD-MM-YYYY"),
        phone: null,
        email: null,
        telegram: null,
        facebook: null,
        line: null,
        title: null,
        marital_status: null,
        emergency_contact: null,
        province_code: null,
        district_code: null,
        commune_code: null,
        village_code: null,
        more_detail_address: null,
        occupation_en: null,
        occupation_kh: null,
        cultural_level: null,
        exam_session: null,
        foreign_languages: null,
        pob: null,
        pob_kh: null,
        is_external: false,
        ref_candidate_id: null,
        photo: null,
        skill_level_detail: [],
      },
    };
  },
  computed: {
    ...mapState("academic/trainerProfile", ["edit_data", "getFormViewDatas"]),
  },
  created() {
    AppOptions.appContentFullHeight = true;
    AppOptions.appContentClass = "p-0";
  },
  methods: {
    ...mapActions("academic/trainerProfile", ["find", "getFormViewData"]),
    async fetchFormViewModel({ index }) {
      this.waiting = true;
      await this.setEditData();
      await this.getFormViewData({
        index: index,
        params: {
          province_code: this.edit_data.province_code,
          district_code: this.edit_data.district_code,
          commune_code: this.edit_data.commune_code,
        },
      });
      this.$refs.profile.setEditData();
      this.waiting = false;
    },
    async photoUpload(trainer_id) {
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        let formData = new FormData();
        formData.append("file", this.model.photo);
        formData.append("trainer_id", trainer_id);
        let response = await this.$store.dispatch(
          "academic/trainerProfile/photoUpload",
          formData
        );
        this.model.photo = response;
      }
      return "";
    },
    async onUpdate() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("academic/trainerProfile/update", {
          id: this.edit_data.trainer_id,
          data: Object.assign({}, this.model),
        })
        .then(async (response) => {
          await this.photoUpload(this.edit_data.trainer_id);
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.$router.push({ name: "trainer-profile" });
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.trainer_id = this.edit_data.trainer_id;
        this.model.fname_kh = this.edit_data.fname_kh;
        this.model.lname_kh = this.edit_data.lname_kh;
        this.model.fname_en = this.edit_data.fname_en;
        this.model.lname_en = this.edit_data.lname_en;
        this.model.sex = this.edit_data.sex;
        this.model.dob = this.edit_data.dob;
        this.model.nationality_id = this.edit_data.nationality_id;
        this.model.register_date = this.edit_data.register_date;
        this.model.phone = this.edit_data.phone;
        this.model.email = this.edit_data.email;
        this.model.telegram = this.edit_data.telegram;
        this.model.facebook = this.edit_data.facebook;
        this.model.line = this.edit_data.line;
        this.model.title = this.edit_data.title;
        this.model.marital_status = this.edit_data.marital_status;
        this.model.emergency_contact = this.edit_data.emergency_contact;
        this.model.province_code = this.edit_data.province_code;
        this.model.district_code = this.edit_data.district_code;
        this.model.commune_code = this.edit_data.commune_code;
        this.model.village_code = this.edit_data.village_code;
        this.model.more_detail_address = this.edit_data.more_detail_address;
        this.model.occupation_en = this.edit_data.occupation_en;
        this.model.occupation_kh = this.edit_data.occupation_kh;
        this.model.cultural_level = this.edit_data.cultural_level;
        this.model.exam_session = this.edit_data.exam_session;
        this.model.foreign_languages = this.edit_data.foreign_languages;
        this.model.pob = this.edit_data.pob;
        this.model.pob_kh = this.edit_data.pob_kh;
        this.model.ref_candidate_id = this.edit_data.ref_candidate_id;
        this.model.is_external = this.edit_data.is_external;
        this.model.skill_level_detail = this.edit_data.level_skills;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchFormViewModel({ params: {}, index: undefined });
    });
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appContentFullHeight = false;
    AppOptions.appContentClass = "";
    next();
  },
};
</script>
